import React, { FC } from 'react'

import { IndicatorsTooltip, Loading } from '@avantstay/backoffice-core'

import { SectionProps } from '@new/__global/components/Section/_types'

import * as S from './Section.styles'

const _Section: FC<SectionProps> = ({
  title,
  hideIndicatorsTooltip = false,
  centerTextInMobile,
  rowTitleStyle,
  afterTitle,
  children,
  innerRef,
  className,
  full,
  scrollable,
  loading,
  tooltipVariables,
  documentationKey,
  tooltipIndicator,
}) => {
  const renderTitle = () =>
    title ? (
      <S.Row center={centerTextInMobile} style={{ ...rowTitleStyle }}>
        {hideIndicatorsTooltip ? (
          <S.Title>{title}</S.Title>
        ) : (
          <IndicatorsTooltip
            title={title}
            documentationKey={documentationKey}
            variables={tooltipVariables}
            indicatorDocs={tooltipIndicator}
          >
            <S.Title>{title}</S.Title>
          </IndicatorsTooltip>
        )}
        {afterTitle && <>&nbsp; {afterTitle}</>}
      </S.Row>
    ) : null

  const getBody = () => (typeof children === 'function' ? (children as any)!() : children)

  return (
    <S.Container ref={innerRef} className={className} full={full} scrollable={scrollable}>
      {renderTitle()}
      {loading ? <Loading /> : getBody()}
    </S.Container>
  )
}

// If you need to wrap this component with HOCs, use them here
export const Section = _Section
